import React, { useState } from "react";
import { Box, Button, Card, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import { changePassword, usChangePassword } from "../../api";
import * as Yup from "yup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import { authTokenPayload } from "../../config/constant";

function ChangePassComp({ userInfo, useridvalue }) {
  const [res, setRes] = useState();

  const formik = useFormik({
    initialValues: {
      UserId: useridvalue,
      password: "",
      newpassword: "",
    },
    validationSchema: Yup.object({
      UserId: Yup.string().max(128).required("userid should be 128bytes"),
      password: Yup.string().max(16).required("password should be 16bytes"),
      newpassword: Yup.string().max(16).required("password should be 16bytes"),
    }),
    onSubmit: async (values) => {
      let json = {
        userid: values.UserId,
        oldpwd: values.password,
        newpwd: values.newpassword,
      };

      const passwordChange = await changePassword(json);

      if (!changePassword?.error) {
        if (userInfo?.apps?.length > 0) {
          try {
            const apikeys = await Promise.all(
              userInfo?.apps
                ?.filter((x) => x?.forum_uri)
                .map(async (app) => {
                  try {
                    if (values.newpassword) {
                      const uri = app.forum_uri.split(":")?.[0];
                      const data = await usChangePassword(
                        uri,
                        authTokenPayload({
                          userid: useridvalue,
                          newpwd: values.newpassword,
                          change_at_login: 0,
                        })
                      );
                    }

                    // const auth = await axios.post(
                    //   `https://${app.forum_uri}/user/authenticate_user`,
                    //   {
                    //     userid: useridvalue,
                    //     pwd: values.newpassword,
                    //   }
                    // );

                    // return { app: app?.appid, apikey: auth?.data?.apikey };
                  } catch (err) {
                    return {};
                  }
                })
            );
          } catch (err) {}
        }
      }

      setRes(passwordChange);

      setTimeout(() => {
        setRes(null);
      }, 3000);
      clearTimeout();
    },
  });

  const [passwordType, setPasswordType] = useState("password" || "text");

  return (
    <Card sx={{ padding: "20px", height: "100%" }}>
      <form onSubmit={formik.handleSubmit}>
        <Box sx={{ my: 3 }}>
          <Typography color="textPrimary" variant="h6">
            Change Password
          </Typography>
        </Box>
        <TextField
          error={Boolean(formik.touched.UserId && formik.errors.UserId)}
          fullWidth
          helperText={formik.touched.UserId && formik.errors.UserId}
          label="User Id"
          margin="normal"
          name="UserId"
          disabled={useridvalue}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          type="text"
          value={formik.values.UserId}
          variant="outlined"
        />
        <TextField
          error={Boolean(formik.touched.password && formik.errors.password)}
          fullWidth
          helperText={formik.touched.password && formik.errors.password}
          label="Password"
          margin="normal"
          name="password"
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          type={passwordType}
          value={formik.values.password}
          variant="outlined"
        />
        <TextField
          error={Boolean(
            formik.touched.newpassword && formik.errors.newpassword
          )}
          fullWidth
          helperText={formik.touched.newpassword && formik.errors.newpassword}
          label="New Password"
          margin="normal"
          name="newpassword"
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          type={passwordType}
          value={formik.values.newpassword}
          variant="outlined"
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(e) => {
                setPasswordType(
                  passwordType === "password" ? "text" : "password"
                );
              }}
            />
          }
          sx={{ userSelect: "none" }}
          label="Show Password"
        />
        <Box sx={{ py: 2 }}>
          <Button
            color="primary"
            disabled={formik.isSubmitting}
            fullWidth
            size="medium"
            type="submit"
            variant="contained"
          >
            Change Password
          </Button>
        </Box>

        {res?.errcode === -1 && (
          <>
            <p style={{ color: "red" }}>{res?.error?.[0]}</p>
          </>
        )}

        {res?.errcode === 0 && (
          <>
            <p style={{ color: "green" }}>{res?.msg?.[0]}</p>
          </>
        )}
      </form>
    </Card>
  );
}

export default ChangePassComp;
